import { SERVICE, SERVICE_PREFIX, PATH_CONNECTOR } from '../constants';

/**
 * 根据服务名称获取服务地址
 * @param {SERVICE} _serviceName
 * @returns
 */
export const makeServicePath = (_serviceName: SERVICE) => {
  return [SERVICE_PREFIX, _serviceName].join(PATH_CONNECTOR);
};

/**
 * 安逸花API服务地址
 */
export const VayhApiServicePath = makeServicePath(SERVICE.VAYH_API);

/**
 * ICR服务地址
 */
export const FinIcrServicePath = makeServicePath(SERVICE.FIN_ICR);
/**
 * ACR服务地址
 */
export const FinAcrServicePath = makeServicePath(SERVICE.FIN_ACR);

/**
 * 根据服务路径和请求路径获取请求地址
 * @param {string} _servicePath 服务路径
 * @param {string} _path 请求路径
 * @returns
 */
export const makeRequestPath = (_servicePath: string, _path) =>
  [_servicePath, _path].join(PATH_CONNECTOR);

/**
 * 获取vayhapi服务的请求地址
 * @param {string} _path
 * @returns
 */
export const getVayhApiRequestPath = (_path: string) => makeRequestPath(VayhApiServicePath, _path);

/**
 * 获取fin-icr服务的请求地址
 * @param {string} _path
 * @returns
 */
export const getIcrRequestPath = (_path: string) => makeRequestPath(FinIcrServicePath, _path);

/**
 * 获取fin-acr服务的请求地址
 * @param {string} _path
 * @returns
 */
export const getAcrRequestPath = (_path: string) => makeRequestPath(FinAcrServicePath, _path);
